import { fromLonLat } from 'ol/proj';

/**
 * Конвертирует координаты из формата 1e7 (целые числа) в проекцию OpenLayers.
 * @param {number} lon - Долгота в формате 1e7.
 * @param {number} lat - Широта в формате 1e7.
 * @returns {number[]} Координаты [x, y] в проекции OpenLayers.
 */
const transformCoords = (lon, lat) => fromLonLat([lon / 10000000, lat / 10000000]);

export default transformCoords;
